import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  Alert,
  IconButton,
  Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFormikContext } from 'formik';
import { PurchaseOptions } from '../schemas/purchase.schemas';
import { useGetPriceQuery } from '../services/purchase.endpoints';

interface DiscountCodeProps {
  productId: string;
}

const DiscountCode: React.FC<DiscountCodeProps> = ({ productId }) => {
  // console.log('discountCode', discountCode);
  const [discountCode, setDiscountCode] = useState('');

  const { values, setFieldValue } = useFormikContext<PurchaseOptions>();

  const { data: prices } = useGetPriceQuery({
    productId,
    discountCode: values.discountCode || undefined,
    copies: values.numberOfCopies || undefined,
    planId: values.selectedPlan || undefined,
  });

  const handleApplyDiscount = () => {
    if (discountCode.trim()) {
      setFieldValue('discountCode', discountCode.trim());
      // setDiscountCode('');
    }
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Have a Promo Code?
      </Typography>
      {prices && prices.discountDetails && (
        <Alert
          severity={prices.discountDetails.success ? 'success' : 'error'}
          action={
            <Tooltip title="Remove applied discount">
              <IconButton
                // color="inherit"
                size="small"
                aria-label="Remove applied discount"
                onClick={() => {
                  setFieldValue('discountCode', '');
                  setDiscountCode('');
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          }
        >
          {prices.discountDetails.message}
        </Alert>
      )}
      <Box display="flex" alignItems="center" gap={2}>
        <TextField
          label="Promo Code"
          placeholder="Enter promo code"
          value={discountCode}
          onChange={(e) => setDiscountCode(e.target.value)}
          name="discountCode"
          variant="outlined"
          fullWidth
          margin="normal"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleApplyDiscount}
          style={{ height: '56px' }}
          disabled={!discountCode.trim()}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default DiscountCode;
